var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('title-row', {
    attrs: {
      "title": "Időszakok",
      "subtitle": _vm.dataTable.itemsLength === -1 ? 'Betöltés...' : `${_vm.dataTable.itemsLength} időszak van a rendszerben`,
      "breadcrumb-items": [{
        text: 'Időszakok',
        disabled: true
      }]
    },
    scopedSlots: _vm._u([{
      key: "buttons",
      fn: function () {
        return [_vm.hasRight('SCHEDULE_WRITE') ? _c('title-row-button', {
          attrs: {
            "to": {
              name: 'NewDateInterval'
            },
            "title": "Hozzáadás"
          }
        }, [_c('v-icon', {
          attrs: {
            "left": ""
          }
        }, [_vm._v("mdi-plus")]), _vm._v(" Új időszak ")], 1) : _vm._e()];
      },
      proxy: true
    }])
  }), _c('v-expansion-panels', {
    staticClass: "mb-4 rounded-xl overflow-hidden",
    attrs: {
      "mandatory": !!Object.values(_vm.search).find(function (e) {
        return e !== '';
      }),
      "flat": ""
    }
  }, [_c('v-expansion-panel', [_c('v-expansion-panel-header', [_c('span', {
    staticClass: "font-weight-medium"
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-magnify")]), _vm._v(" Keresés ")], 1)]), _c('v-expansion-panel-content', [_c('v-row', {
    staticClass: "mt-2"
  }, [_c('v-col', {
    attrs: {
      "cols": 12,
      "sm": 4,
      "md": 3
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Megnevezés",
      "clearable": "",
      "hide-details": "",
      "filled": ""
    },
    on: {
      "input": _vm.searchEventHandler
    },
    model: {
      value: _vm.search.name,
      callback: function ($$v) {
        _vm.$set(_vm.search, "name", $$v);
      },
      expression: "search.name"
    }
  })], 1)], 1)], 1)], 1)], 1), _c('v-card', {
    staticClass: "rounded-xl",
    attrs: {
      "flat": ""
    }
  }, [_c('v-data-table', {
    attrs: {
      "loading": _vm.loading,
      "headers": _vm.dataTable.headers,
      "items": _vm.dataTable.items,
      "server-items-length": _vm.dataTable.itemsLength,
      "options": _vm.dataTable.options,
      "footer-props": _vm.$config.dataTableFooterProps
    },
    on: {
      "update:options": function ($event) {
        return _vm.$set(_vm.dataTable, "options", $event);
      }
    },
    scopedSlots: _vm._u([{
      key: `item.d`,
      fn: function (_ref) {
        var item = _ref.item;
        return [_vm._v(_vm._s(_vm._f("moment")(item.start_date, 'll')) + " - " + _vm._s(_vm._f("moment")(item.end_date, 'll')))];
      }
    }, {
      key: `item.is_recurring`,
      fn: function (_ref2) {
        var item = _ref2.item;
        return [_c('v-icon', {
          attrs: {
            "color": item.is_recurring ? 'success' : 'error'
          }
        }, [_vm._v(" " + _vm._s(item.is_recurring ? 'mdi-check' : 'mdi-close') + " ")])];
      }
    }, {
      key: `item.actions`,
      fn: function (_ref3) {
        var item = _ref3.item;
        return [_vm.hasRight('SCHEDULE_WRITE') ? _c('v-btn', {
          staticClass: "rounded-sm ma-1",
          attrs: {
            "text": "",
            "fab": "",
            "small": "",
            "dark": "",
            "color": "primary",
            "to": {
              name: 'DateIntervalEditor',
              params: {
                id: item.id
              }
            },
            "title": "Szerkesztés"
          }
        }, [_c('v-icon', [_vm._v("mdi-pencil")])], 1) : _vm._e(), _vm.hasRight('SCHEDULE_WRITE') ? _c('v-btn', {
          staticClass: "rounded-sm ma-1",
          attrs: {
            "text": "",
            "fab": "",
            "small": "",
            "dark": "",
            "color": "primary",
            "title": "Törlés"
          },
          on: {
            "click": function ($event) {
              return _vm.deleteDateInterval(item);
            }
          }
        }, [_c('v-icon', [_vm._v("mdi-delete")])], 1) : _vm._e()];
      }
    }], null, true)
  })], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }